import * as UIKit from "~/src/modules/ui-kit";

export default function ParameterValue(props) {
    const { children, id, label, ...restProps } = props;

    if (!id) return undefined;

    return (
        <UIKit.Card { ...restProps }>
            <UIKit.LetterBackdrop>PV</UIKit.LetterBackdrop>
            <UIKit.CardFace2>
                <span className="fluid-accent">{ label[0]?.text }</span>
                <span>{ id }</span>
            </UIKit.CardFace2>
            { children }
        </UIKit.Card>
    );
}
